/**
 * Tarifs et abonnements (la console commerciale, ADR-0018 §4a), en français,
 * la langue de référence. Fusionné dans fr.ts ; chaque autre langue a un
 * billing.<lang>.ts avec exactement les mêmes clés. L'écran n'affiche que ce
 * que l'API répond : `inForce`, `state`, `entitled`, `subscriberCount`.
 */
export const billingFr = {
  "billing.tabs.aria": "Tarifs et abonnements",
  "billing.tab.prices": "Prix",
  "billing.tab.promos": "Promos",
  "billing.tab.discounts": "Remises",
  "billing.refreshFailed": "La liste n'a pas pu être actualisée : elle est affichée telle qu'elle était.",
  "billing.anyPlan": "Tous les forfaits",
  "billing.planWithInterval": "{name}, facturé {interval}",
  "billing.interval.month": "par mois",
  "billing.interval.year": "par an",
  "billing.window": "du {from} au {to}",
  "billing.window.endedEarly": "arrêtée le {date}",
  "billing.periods.whileSubscribed": "tant que le pro reste abonné",
  "billing.periods.count": "{count} périodes payées",
  "billing.state.scheduled": "Programmée",
  "billing.state.running": "En cours",
  "billing.state.finished": "Terminée",
  "billing.state.ended_early": "Arrêtée avant la fin",
  "billing.scope.pro": "Un pro",
  "billing.scope.country": "Un pays",
  "billing.scope.category": "Un métier",
  "billing.priceState.in_force": "En vigueur",
  "billing.priceState.scheduled": "Programmé",
  "billing.priceState.superseded": "Remplacé",
  "billing.prices.intro":
    "Un nouveau prix ne s'applique qu'aux nouveaux abonnements. Un pro garde le prix auquel il s'est abonné.",
  "billing.prices.loading": "Chargement des prix…",
  "billing.prices.loadFailed": "Impossible de charger les prix.",
  "billing.prices.empty": "Aucun prix n'est encore défini.",
  "billing.prices.unpriced": "Sans prix : {plans}. Personne ne peut s'y abonner.",
  "billing.prices.imported": "Repris du tarif d'origine",
  "billing.promos.intro":
    "Une promo baisse le prix d'un forfait dans un pays, pour qui s'abonne pendant sa fenêtre. Un pro obtient le prix le plus bas : promo et remise ne se cumulent pas.",
  "billing.promos.loading": "Chargement des promos…",
  "billing.promos.loadFailed": "Impossible de charger les promos.",
  "billing.promos.empty": "Aucune promo pour l'instant.",
  "billing.discounts.intro":
    "Une remise est un pourcentage pour un pro, un pays ou un métier. Un pro obtient le prix le plus bas : remise et promo ne se cumulent pas.",
  "billing.discounts.loading": "Chargement des remises…",
  "billing.discounts.loadFailed": "Impossible de charger les remises.",
  "billing.discounts.empty": "Aucune remise pour l'instant.",
  "billing.col.name": "Nom",
  "billing.col.plan": "Forfait",
  "billing.col.country": "Pays",
  "billing.col.currency": "Devise",
  "billing.col.amount": "Montant",
  "billing.col.amountDue": "Reste à payer",
  "billing.col.promoPrice": "Prix promo",
  "billing.col.percentOff": "Remise",
  "billing.col.periods": "Durée",
  "billing.col.window": "Fenêtre",
  "billing.col.state": "État",
  "billing.col.status": "Statut du paiement",
  "billing.col.subscribers": "Pros concernés",
  "billing.col.createdBy": "Créée par",
  "billing.col.setBy": "Défini par",
  "billing.col.reason": "Motif",
  "billing.col.validFrom": "À partir du",
  "billing.col.who": "Pour qui",
  "billing.col.actions": "Actions",
  "billing.col.date": "Date",
  "billing.col.period": "Période couverte",
  "billing.col.provider": "Fournisseur",
  "billing.col.eventKind": "Événement",
  "billing.col.via": "Reçu par",
  "billing.col.result": "Résultat",
  "billing.col.detail": "Détail",
  "billing.col.eventRef": "Référence de l'événement",
  "billing.action.setPrice": "Définir un prix",
  "billing.action.newPromo": "Nouvelle promo",
  "billing.action.newDiscount": "Nouvelle remise",
  "billing.action.endNow": "Arrêter maintenant",
  "billing.action.endPromo": "Arrêter la promo",
  "billing.action.endDiscount": "Arrêter la remise",
  "billing.action.extendSubscription": "Prolonger",
  "billing.action.endSubscription": "Terminer l'abonnement",
  "billing.dialog.setPrice.title": "Définir un prix",
  "billing.dialog.setPrice.body":
    "Ce prix s'appliquera aux nouveaux abonnements dans ce pays. Les pros déjà abonnés gardent le leur.",
  "billing.dialog.newPromo.title": "Nouvelle promo",
  "billing.dialog.newPromo.body":
    "Le prix promo remplace le prix du pays pendant la fenêtre. Un pro le garde tant qu'il reste abonné, dans la limite indiquée.",
  "billing.dialog.newDiscount.title": "Nouvelle remise",
  "billing.dialog.newDiscount.body":
    "Choisissez un seul destinataire : un pro, un pays ou un métier. Un pro obtient le prix le plus bas : remise et promo ne se cumulent pas.",
  "billing.dialog.endPromo.title": "Arrêter la promo {subject}",
  "billing.dialog.endPromo.body": "Plus personne ne pourra la prendre. Les pros déjà dessus la gardent.",
  "billing.dialog.endDiscount.title": "Arrêter la remise {subject}",
  "billing.dialog.endDiscount.body":
    "Elle ne s'appliquera plus à de nouveaux abonnements. Les pros déjà dessus la gardent.",
  "billing.dialog.extendSubscription.title": "Prolonger {subject}",
  "billing.dialog.extendSubscription.body":
    "Geste commercial : l'accès est prolongé jusqu'à la date choisie et une suspension est levée. Le prix du pro ne change pas.",
  "billing.dialog.endSubscription.title": "Terminer l'abonnement {subject}",
  "billing.dialog.endSubscription.body":
    "L'accès s'arrête tout de suite et le fournisseur reçoit l'ordre de ne plus prélever. Il n'y a pas de remboursement : accordez un crédit depuis Paiements s'il est dû.",
  "billing.field.plan": "Forfait",
  "billing.field.pickPlan": "Choisir un forfait",
  "billing.field.country": "Pays",
  "billing.field.countryHint": "Code à deux lettres, par exemple GN.",
  "billing.field.currency": "Devise",
  "billing.field.currencyHint": "Code à trois lettres, par exemple GNF.",
  "billing.field.amount": "Prix ({currency})",
  "billing.field.validFrom": "À partir du (facultatif)",
  "billing.field.validFromHint": "Vide : le prix s'applique tout de suite. Jamais une date passée.",
  "billing.field.name": "Nom",
  "billing.field.nameHint": "Ce que l'équipe verra dans la liste, par exemple « Lancement Conakry ».",
  "billing.field.startsAt": "Début",
  "billing.field.endsAt": "Fin",
  "billing.field.periods": "Nombre de périodes (facultatif)",
  "billing.field.periodsHint": "Vide : le pro garde le prix tant qu'il reste abonné.",
  "billing.field.scope": "Pour qui",
  "billing.field.pro": "Le pro",
  "billing.field.category": "Métier",
  "billing.field.pickCategory": "Choisir un métier",
  "billing.field.percentOff": "Pourcentage de remise",
  "billing.field.paidThrough": "Prolonger jusqu'au",
  "billing.field.paidThroughHint": "Une date à venir. L'accès court jusque-là.",
  "billing.problem.reason": "Donnez un motif d'au moins {min} caractères.",
  "billing.problem.plan": "Choisissez un forfait.",
  "billing.problem.country": "Saisissez un code pays de deux lettres.",
  "billing.problem.currency": "Saisissez un code devise de trois lettres.",
  "billing.problem.amount": "Saisissez un montant supérieur à zéro.",
  "billing.problem.validFrom": "Donnez une date de début valable.",
  "billing.problem.backdated": "Un prix ne peut pas commencer dans le passé.",
  "billing.problem.name": "Donnez un nom d'au moins {min} caractères.",
  "billing.problem.window": "Donnez un début et une fin.",
  "billing.problem.windowOrder": "La fin doit venir après le début.",
  "billing.problem.periods": "Le nombre de périodes doit être un entier supérieur à zéro.",
  "billing.problem.pro": "Choisissez le pro concerné.",
  "billing.problem.category": "Choisissez un métier.",
  "billing.problem.percentOff": "Le pourcentage doit être un entier entre 1 et 100.",
  "billing.problem.paidThrough": "Donnez une date de fin valable.",
  "billing.problem.paidThroughPast": "La date doit être à venir.",
  "billing.outcome.price": "Prix enregistré : {amount}, à partir du {date}.",
  "billing.outcome.promoCreated": "Promo « {name} » créée.",
  "billing.outcome.promoEnded": "Promo « {name} » arrêtée. Les pros déjà dessus la gardent.",
  "billing.outcome.discountCreated": "Remise « {name} » créée.",
  "billing.outcome.discountEnded": "Remise « {name} » arrêtée. Les pros déjà dessus la gardent.",
  "billing.outcome.extended": "Abonnement prolongé jusqu'au {date}.",
  "billing.outcome.subscriptionEnded": "Abonnement terminé. L'accès est coupé et le fournisseur ne prélèvera plus.",
  "billing.error.stale": "Ceci a changé pendant que vous le regardiez. Rechargez, vérifiez, puis recommencez.",
  "billing.error.refused":
    "Refusé : vos rôles n'incluent pas la fonctionnalité nécessaire. Demandez l'accès à un responsable.",
  "billing.error.invalid": "Refusé : ce qui a été envoyé ne convient plus. Rechargez et vérifiez.",
  "billing.error.outcomeUnknown":
    "Pas de réponse du serveur : l'enregistrement a peut-être eu lieu. Réessayez : le même clic ne peut pas être appliqué deux fois.",
  "billing.refused.planNotPriced": "Refusé : ce forfait n'a pas encore de prix dans ce pays. Définissez-le d'abord.",
  "billing.refused.invalidAmount": "Refusé : le montant doit être supérieur à zéro.",
  "billing.refused.backdated": "Refusé : un prix ne peut pas commencer dans le passé.",
  "billing.refused.priceVersionExists":
    "Refusé : une version commence déjà à ce moment pour ce forfait et ce pays. Rechargez la liste.",
  "billing.refused.invalidWindow": "Refusé : la fenêtre n'est pas valable. La fin doit venir après le début.",
  "billing.refused.alreadyOver": "Refusé : c'est déjà terminé. Rechargez la liste.",
  "billing.refused.idempotencyKeyRequired":
    "Refusé : la demande est partie sans sa clé. Fermez la fenêtre et recommencez.",
  "billing.subscription.pending": "En attente",
  "billing.subscription.active": "Actif",
  "billing.subscription.ending": "Sans renouvellement",
  "billing.subscription.suspended": "Suspendu",
  "billing.subscription.ended": "Terminé",
  "billing.endReason.renewal_cancelled": "Renouvellement annulé par le pro",
  "billing.endReason.unpaid": "Renouvellement impayé",
  "billing.endReason.checkout_abandoned": "Paiement jamais terminé",
  "billing.endReason.replaced": "Remplacé par un autre abonnement",
  "billing.endReason.ended_by_staff": "Terminé par l'équipe",
  "billing.endReason.ended_by_provider": "Terminé par le fournisseur",
  "billing.event.payment_succeeded": "Paiement réussi",
  "billing.event.payment_failed": "Paiement échoué",
  "billing.event.subscription_ended": "Abonnement terminé",
  "billing.via.webhook": "Notification du fournisseur",
  "billing.via.poll": "Vérification par Walliyo",
  "billing.via.return": "Retour du pro dans l'app",
  "billing.via.reconcile": "Rapprochement",
  "billing.result.applied": "Appliqué",
  "billing.result.conflict": "Conflit",
  "billing.result.ignored": "Ignoré",
  "billing.priceInsteadOf": "{now} au lieu de {regular}",
  "billing.reductionWithPeriods": "{name} · {count} périodes restantes",
  "billing.sub.loading": "Chargement de l'abonnement…",
  "billing.sub.loadFailed": "Impossible de charger l'abonnement.",
  "billing.sub.none": "Ce pro n'a jamais été abonné.",
  "billing.sub.credit": "Crédit",
  "billing.sub.noCredit": "Aucun",
  "billing.sub.noRefunds":
    "Il n'y a pas de remboursement sur un abonnement. Un geste est un crédit, accordé depuis Paiements, déduit du prochain paiement.",
  "billing.sub.creditLink": "Ses paiements, pour accorder un crédit →",
  "billing.sub.discountLink": "Offrir une remise à ce pro →",
  "billing.sub.since": "Ouvert le {date}",
  "billing.sub.versionTitle": "La version de l'abonnement affichée : chaque écriture l'envoie.",
  "billing.sub.entitled": "Accès ouvert",
  "billing.sub.notEntitled": "Pas d'accès",
  "billing.sub.provider": "Fournisseur",
  "billing.sub.renewsAutomatically": "renouvellement automatique",
  "billing.sub.paidByHand": "payé à la main par le pro",
  "billing.sub.country": "Pays",
  "billing.sub.price": "Prix actuel",
  "billing.sub.reduction": "Réduction",
  "billing.sub.nextPlan": "Changement de forfait",
  "billing.sub.nextPlanValue": "passe à {plan} à la fin de la période",
  "billing.sub.paidThrough": "Payé jusqu'au",
  "billing.sub.renewalCancelled": "Renouvellement annulé le",
  "billing.sub.graceEnds": "Délai de grâce jusqu'au",
  "billing.sub.ended": "Terminé le",
  "billing.sub.endReason": "Raison de la fin",
  "billing.sub.payments": "Paiements",
  "billing.sub.noPayments": "Aucun paiement sur cet abonnement.",
  "billing.sub.noPeriod": "Pas encore couverte",
  "billing.sub.events": "Événements du fournisseur",
  "billing.sub.noEvents": "Aucun événement du fournisseur.",
  "billing.sub.actions": "Agir sur cet abonnement",
  "billing.sub.actionsFoot":
    "Prolonger est un geste commercial, terminer une sanction. Les deux demandent un motif et sont enregistrés au journal d'audit.",
} as const;

export type BillingMessageId = keyof typeof billingFr;
